import script from "./TextInputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextInputField.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__